import { DisputeEvidence, FileEvidenceType } from './payments.types';

const fileEvidence: FileEvidenceType[] = [
  'cancellation_policy',
  'customer_communication',
  'customer_signature',
  'duplicate_charge_documentation',
  'receipt',
  'refund_policy',
  'service_documentation',
  'shipping_documentation',
  'uncategorized_file',
];

export const transformEvidence = (evidence: DisputeEvidence) =>
  Object.entries(evidence).reduce((acc, [key, value]) => {
    const camelCase = key.replace(/(_\w)/g, m => m.toUpperCase().substring(1));
    const isFileEvidence = fileEvidence.includes(key as FileEvidenceType);
    if (isFileEvidence) {
      // Whatever I'm just casting here. Don't feel like figuring out the TS
      acc[`${camelCase}FileId`] = (value as { id: string }).id;
    } else {
      acc[camelCase] = value;
    }
    return acc;
  }, {});
